import { webMediaRecorder } from './start-web-recording.js';

/**
 * Resume web recording
 * @returns {Promise<void>}
 */
export const resumeWebRecording = async () => {
  if (!webMediaRecorder) {
    throw new Error('No web recording in progress');
  }

  if (webMediaRecorder.state === 'paused') {
    webMediaRecorder.resume();
    console.log('Web recording resumed');
  } else {
    throw new Error('Recording is not paused, cannot resume');
  }
};
